export function register(config) {
  // Early exit in dev mode unless explicitly enabled, or if SW unsupported.
  const enableSwInDev = import.meta.env.VITE_ENABLE_SW_IN_DEV === "true";
  const isProd = process.env.NODE_ENV === "production";

  if ((!isProd && !enableSwInDev) || !("serviceWorker" in navigator)) return;

  const callRegister = () => registerValidSW(config);
  // Safari-friendly: defer registration to reduce startup contention.
  window.requestIdleCallback ? requestIdleCallback(callRegister) : setTimeout(callRegister, 1500);
}

const registerValidSW = async (config) => {
  const swUrl = "/service-worker.js";

  try {
    const registration = await navigator.serviceWorker.register(swUrl);
    console.log("Service Worker registered", registration);

    // If offline, immediately activate waiting worker if present.
    if (!navigator.onLine && registration.waiting) {
      registration.waiting.postMessage({ type: "SKIP_WAITING" });
    }

    if (config?.onSuccess) {
      config.onSuccess(registration);
    }

    registration.onupdatefound = () => {
      const worker = registration.installing;
      if (!worker) return;

      worker.onstatechange = () => {
        if (worker.state === "installed" && navigator.serviceWorker.controller) {
          console.log(
            "New content is available and will be used when all tabs for this page are closed.",
          );
          if (config?.onUpdate) {
            config.onUpdate(registration);
          }
        }
      };
    };
  } catch (err) {
    console.error("SW registration failed:", err);
  }

  // Safari/Firefox may not support these APIs; guard each one.
  navigator.serviceWorker.ready.then(async (registration) => {
    if ("sync" in registration) {
      try {
        await registration.sync.register("sync-data");
        console.log("Background sync registered.");
      } catch (err) {
        console.warn("Background sync failed:", err);
      }
    }

    if ("periodicSync" in registration) {
      try {
        await registration.periodicSync.register("content-sync", {
          minInterval: 24 * 60 * 60 * 1000,
        });
        console.log("Periodic background sync registered.");
      } catch (err) {
        console.warn("Periodic sync failed:", err);
      }
    }
  });
};

export function unregister() {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}
